(() => {
  if (window.dioNativeFormsLoaded) return;
  window.dioNativeFormsLoaded = true;
  const lifetime = 20 * 60 * 1000;
  function init() {
    document.querySelectorAll('[data-dio-native-flow]').forEach(root => {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      const contact = root.querySelector('form.dio-custom-form');
      const signup = root.querySelector('form.dio-native-signup');
      const fields = root.querySelector('[data-contact-fields]');
      const received = root.querySelector('[data-request-confirmation]');
      const status = root.querySelector('[data-signup-status]');
      const panel = root.querySelector('[data-signup-panel]');
      const messages = JSON.parse(root.querySelector('[data-native-messages]').textContent);
      const key = 'dio-native:' + location.pathname + ':' + root.dataset.dioNativeFlow;
      let busy = false;
      const read = () => {
        try {
          const value = JSON.parse(sessionStorage.getItem(key));
          if (value && Date.now() - value.time < lifetime && value.time <= Date.now()) return value;
          sessionStorage.removeItem(key);
        } catch {}
        return null;
      };
      const write = value => {
        try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {}
      };
      const focus = node => {
        node.focus({preventScroll: true});
        node.scrollIntoView({block: 'center', behavior: 'smooth'});
      };
      const show = (message, error = false) => {
        status.textContent = message;
        status.hidden = false;
        status.toggleAttribute('data-error', error);
        status.setAttribute('role', error ? 'alert' : 'status');
      };
      const showReceived = () => {
        fields.hidden = true;
        received.hidden = false;
        contact.removeAttribute('aria-busy');
      };
      const fillSignup = value => {
        signup.elements.namedItem('contact[email]').value = value.email || '';
        signup.elements.namedItem('contact[first_name]').value = value.first || '';
        signup.elements.namedItem('contact[last_name]').value = value.last || '';
      };
      const finish = subscribed => {
        write({time: Date.now(), stage: 'done', subscribed});
        showReceived();
        panel.hidden = true;
        if (subscribed) show(messages.saved);
        else status.hidden = true;
        focus(received);
      };
      const protect = () => new Promise((resolve, reject) => {
        const api = window.Shopify && window.Shopify.captcha;
        if (!api || typeof api.protect !== 'function') { resolve(); return; }
        const timer = setTimeout(() => reject(new Error('captcha_timeout')), 15000);
        try { api.protect(signup, () => { clearTimeout(timer); resolve(); }); }
        catch (error) { clearTimeout(timer); reject(error); }
      });
      const sendSignup = async value => {
        if (busy) return;
        busy = true;
        fillSignup(value);
        showReceived();
        panel.hidden = true;
        show(messages.saving);
        write({...value, time: Date.now(), stage: 'signup'});
        const button = signup.querySelector('button[type=submit]');
        button.disabled = true;
        signup.setAttribute('aria-busy', 'true');
        try {
          await protect();
          const action = new URL(signup.action, location.href);
          if (action.origin !== location.origin || !action.pathname.endsWith('/contact')) throw new Error('unexpected_action');
          const data = new URLSearchParams();
          new FormData(signup).forEach((entry, name) => { if (typeof entry === 'string') data.append(name, entry); });
          const response = await fetch(action.href, {
            method: 'POST', body: data, credentials: 'same-origin',
            signal: AbortSignal.timeout(30000)
          });
          const finalURL = new URL(response.url || action.href, location.href);
          if (finalURL.origin === location.origin && /\/challenge\/?$/.test(finalURL.pathname)) {
            HTMLFormElement.prototype.submit.call(signup);
            return;
          }
          if (!response.ok || finalURL.origin !== location.origin) throw new Error('signup_unconfirmed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const returned = doc.getElementById(signup.id);
          const result = returned && returned.querySelector('[data-dio-signup-result]');
          if (!result || result.dataset.dioSignupResult !== 'success') throw new Error('signup_unconfirmed');
          finish(true);
        } catch {
          write({...value, time: Date.now(), stage: 'contact_saved'});
          panel.hidden = false;
          show(messages.retry, true);
          focus(status);
        } finally {
          busy = false;
          button.disabled = false;
          signup.removeAttribute('aria-busy');
        }
      };
      contact.addEventListener('submit', event => {
        if (!contact.checkValidity()) return;
        const data = new FormData(contact);
        const name = String(data.get('contact[name]') || '').trim().split(/\s+/);
        const consent = contact.querySelector('[data-email-marketing]').checked;
        write({time: Date.now(), stage: 'contact', optin: consent,
          email: consent ? String(data.get('contact[email]') || '') : '',
          first: consent ? String(data.get('contact[first_name]') || name.shift() || '') : '',
          last: consent ? String(data.get('contact[last_name]') || name.join(' ') || '') : ''});
        contact.dataset.submitting = 'true';
        contact.setAttribute('aria-busy', 'true');
      });
      signup.addEventListener('submit', event => {
        event.preventDefault();
        if (!signup.reportValidity()) return;
        const data = new FormData(signup);
        sendSignup({email: String(data.get('contact[email]') || ''),
          first: String(data.get('contact[first_name]') || ''),
          last: String(data.get('contact[last_name]') || ''), optin: true});
      });
      root.querySelector('[data-new-request]').addEventListener('click', () => {
        try { sessionStorage.removeItem(key); } catch {}
        fields.hidden = false;
        received.hidden = true;
        status.hidden = true;
        panel.hidden = true;
        contact.dataset.submitting = '';
        contact.reset();
        root.querySelector('[data-dio-contact-result]').dataset.dioContactResult = 'idle';
        const url = new URL(location.href);
        url.searchParams.delete('contact_posted');
        url.searchParams.delete('customer_posted');
        history.replaceState(null, '', url.href);
        fields.querySelector('input:not([type=hidden])').focus();
      });
      const purchase = contact.querySelector('[name="contact[purchase_date]"]');
      if (purchase) {
        const now = new Date();
        purchase.max = [now.getFullYear(), String(now.getMonth()+1).padStart(2,'0'), String(now.getDate()).padStart(2,'0')].join('-');
      }
      window.addEventListener('pageshow', () => {
        contact.dataset.submitting = '';
        contact.removeAttribute('aria-busy');
      });
      const pending = read();
      const contactOK = root.querySelector('[data-dio-contact-result]').dataset.dioContactResult === 'success';
      const signupOK = root.querySelector('[data-dio-signup-result]').dataset.dioSignupResult === 'success';
      if (pending && pending.stage === 'done') finish(pending.subscribed);
      else if (pending && pending.stage === 'contact' && contactOK) {
        if (pending.optin) sendSignup(pending);
        else finish(false);
      } else if (pending && pending.stage === 'signup' && signupOK) finish(true);
      else if (pending && ['signup','contact_saved'].includes(pending.stage)) {
        showReceived(); fillSignup(pending); panel.hidden = false; show(messages.retry, true);
      } else if (contactOK) {
        showReceived(); panel.hidden = false; show(messages.storage); focus(received);
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
